import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('hcc_cookie_consent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('hcc_cookie_consent', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-consent-banner">
            <div className="cookie-content">
                <p>
                    We use cookies to enhance your browsing experience and analyze our traffic. 
                    By continuing to use our website, you consent to our use of cookies.
                </p>
                <button className="btn btn-primary cookie-btn" onClick={handleAccept}>
                    Accept
                </button>
            </div>
        </div>
    );
};

export default CookieConsent;
